import React from 'react';
import { Badge } from './ui/badge';
import { serviceStates } from '../mock/data';
import { MapPin } from 'lucide-react';

const ServiceAreas = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 border-2 border-gray-100">
          <div className="flex items-center justify-center mb-8">
            <MapPin className="w-8 h-8 text-[#3B5275] mr-3" />
            <h3 className="text-3xl md:text-4xl font-bold text-[#3B5275]">
              Service Areas
            </h3>
          </div>
          <p className="text-center text-gray-600 mb-8 text-lg">
            Licensed and operating in 16 states across the nation
          </p>
          
          <div className="flex flex-wrap justify-center gap-3">
            {serviceStates.map((state) => (
              <Badge 
                key={state.code}
                variant={state.primary ? "default" : "secondary"}
                className={`${
                  state.primary 
                    ? 'bg-[#152238] hover:bg-[#1a2d47] text-white' 
                    : 'bg-blue-100 hover:bg-blue-200 text-[#3B5275]'
                } px-6 py-3 text-base font-semibold cursor-pointer transition-all duration-300 hover:scale-110`}
              >
                {state.code} - {state.name}
              </Badge>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreas;
